<template>
  <div id="memberList">
    <div class="common_tit_wrap">
      <div class="common_page_tit">사용자 현황</div>
    </div>
    <div class="common_search_wrap">
      <div>
        <div class="common_search_item quarter3_width">
          <label>소속</label>
          <div>
            <select v-model="searchParams.afcSelect">
              <option value="">미선택</option>
              <option v-for="item in afcList" :key="'afc_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
            <select v-model="searchParams.ofc1Select" @change="getOfc2List(searchParams.ofc1Select)">
              <option value="">미선택</option>
              <option v-for="item in ofc1List" :key="'ofc1_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
            <select v-model="searchParams.ofc2Select">
              <option value="">미선택</option>
              <option v-for="item in searchParams.ofc2List" :key="'ofc2_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
        <div class="common_search_item">
          <label>담당업무</label>
          <div>
            <select v-model="searchParams.rwkSelect">
              <option value="">미선택</option>
              <option v-for="item in rwkList" :key="'rwk_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
        <div class="common_search_item quarter3_width">
          <label>키워드</label>
          <div>
            <select v-model="searchParams.searchKeywordSelect">
              <option value="">없음</option>
              <option v-for="item in searchKeywordTypeList" :key="'keyword_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
            <input type="text" v-model="searchParams.searchKeyword"/>
            <div class="btn_search" @click="search(1)">검색</div>
          </div>
        </div>
      </div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model="selectSize" @change="search(1)">
<!--            <option value="10">10줄 표시</option>-->
<!--            <option value="20">20줄 표시</option>-->
            <option value="50">50줄 표시</option>
            <option value="100">100줄 표시</option>
            <option value="200">200줄 표시</option>
            <option value="500">500줄 표시</option>
          </select>
        </div>
        <div class="btn_top btn_green" @click="addMember">신규 사용자 등록</div>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>이름</span></div>
          <div><span>아이디</span></div>
          <div><span>본부</span></div>
          <div><span>소속</span></div>
          <div><span>소속팀</span></div>
          <div><span>직급</span></div>
          <div><span>담당업무</span></div>
          <div><span>전화번호</span></div>
          <div><span>상태</span></div>
<!--          <div><span>계정이력</span></div>-->
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'member_' + item.userPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" @click.stop="onClickCheckItem(item)"/></span></div>
            <div><span class="link fc_primary_blue" @click="editMember(item)">{{item.userName}}</span></div>
            <div><span>{{item.userId}}</span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.affiliateCode != null">
                <template v-for="afc in afcList" v-if="afc.codeValue === item.affiliateCode">{{afc.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span>{{item.teamName}}</span></div>
            <div><span>{{item.jobRank}}</span></div>
            <div>
              <span v-if="item.chargeCode != null">
                <template v-for="rwk in rwkList" v-if="rwk.codeValue === item.chargeCode">{{rwk.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span>{{item.mobilePhone}}</span></div>
            <div>
              <template v-if="item.useState != null">
                <template v-for="ust in useStateList" v-if="ust.codeValue === item.useState">
                  <span :key="'ust_' + ust.codeValue" :class="item.useState === 0 ? 'fc_green' : item.useState === 2 || item.useState === 3 ? 'fc_red' : ''">{{ust.codeName}}</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
<!--            <div><span class="link fc_primary_blue">이력보기</span></div>-->
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <select v-model="useStateSelect">
          <option value="">--일괄작업--</option>
          <option v-for="item in useStateList" :key="'userStatus_' + item.codePid" :value="item.codeValue" v-if="item.codeValue !== 0">{{item.codeName}}</option>
        </select>
        <div class="btn_apply" @click="changeUseState">적용</div>
        <div class="btn_bottom btn_green_t" @click="downloadExcel">엑셀 다운로드</div>
        <div class="common_list_page_wrap">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
      </div>
    </div>
    <excel-exporter ref="excel" :filter="memberFilter" :type="'member'" @downloading="excelDownloadStarted" @fail="excelDownloadFail"/>
    <modal name="loadingProgress" classes="loading_progress_wrap" width="300px" height="200px">
      <div>{{progressMsg}}</div>
    </modal>
  </div>
</template>

<script>
import common from '../../script/common'
import user from '../../script/user'
import ExcelExporter from '../excel/ExcelExporter.vue'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {ExcelExporter},
  data () {
    return {
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      rwkList: [],
      useStateList: common.useStateList(),
      // Search
      searchKeywordTypeList: [
        { codePid: 0, codeValue: 'id', codeName: '아이디' },
        { codePid: 1, codeValue: 'name', codeName: '이름' }
      ],
      searchParams: {
        afcSelect: '', // 소속 선택
        ofc1Select: '', // 본부 1차 선택
        ofc2List: [],
        ofc2Select: '', // 본부 2차 선택
        rwkSelect: '', // 담당업무 선택
        searchKeywordSelect: '', // 키워드 분류 선택
        searchKeyword: '' // 키워드
      },
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '50',
      list: [],
      checkAll: false,
      selectedUserList: [],
      // Change State
      useStateSelect: '',
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      },
      // Popup
      popupParams: {
        title: '',
        component: '',
        data: {}
      },
      // Excel Download
      memberFilter: {
        page: 1,
        size: 100000,
        list: true
      },
      excelDownloading: false,
      // loading
      progressMsg: '',
      vueLoadingOverlay: null
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              this.searchParams = this.$route.params.searchParams
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List (ofc) {
      this.searchParams.ofc2Select = ''
      this.searchParams.ofc2List = this.ofcList.filter(item => { return item.codeParent === ofc })
    },
    onClickCheckAll () {
      this.selectedUserList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedUserList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedUserList = this.selectedUserList.filter(item => { return item.userPid !== selectedItem.userPid })
      } else {
        this.selectedUserList.push(selectedItem)
      }
      this.checkAll = this.selectedUserList.length === this.list.length
    },
    changeUseState () {
      if (this.selectedUserList.length === 0) {
        common.amsAlert('general', '먼저 사용자를 선택해주세요.')
        return
      }
      let list = []
      for (let i = 0; i < this.selectedUserList.length; i++) {
        list.push(this.selectedUserList[i].userPid)
      }
      user.useStates({
        userList: list,
        useState: this.useStateSelect
      }, response => {
        console.log('useStates', response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '일괄작업을 적용했습니다.')
          this.search(this.filter.page)
        } else {
          common.amsAlert('retry', '일괄작업을 적용하지 못했습니다.')
        }
      })
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize),
        list: true
      }
      if (this.searchParams.afcSelect != null && this.searchParams.afcSelect !== '') {
        this.filter.affiliateCode = this.searchParams.afcSelect
      } else {
        delete this.filter['affiliateCode']
      }
      if (this.searchParams.ofc1Select != null && this.searchParams.ofc1Select !== '') {
        this.filter.officeCode = this.searchParams.ofc1Select
        if (this.searchParams.ofc2Select != null && this.searchParams.ofc2Select !== '') {
          this.filter.officeCode = this.searchParams.ofc2Select
        }
      } else {
        delete this.filter['officeCode']
      }
      if (this.searchParams.rwkSelect != null && this.searchParams.rwkSelect !== '') {
        this.filter.chargeCode = this.searchParams.rwkSelect
      } else {
        delete this.filter['chargeCode']
      }
      delete this.filter['userId']
      delete this.filter['userName']
      if (this.searchParams.searchKeywordSelect != null && this.searchParams.searchKeywordSelect !== '' &&
        this.searchParams.searchKeyword != null && this.searchParams.searchKeyword.length > 0) {
        if (this.searchParams.searchKeywordSelect === 'id') {
          this.filter.userId = this.searchParams.searchKeyword
        } else if (this.searchParams.searchKeywordSelect === 'name') {
          this.filter.userName = this.searchParams.searchKeyword
        }
      }
      this.updateList()
    },
    updateList () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      user.getUser(this.filter, response => {
        console.log('getUser', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '계정관리 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
        this.selectedUserList = []
      })
    },
    showPopup (title, component, data) {
      this.popupParams.title = title
      this.popupParams.component = component
      this.popupParams.data = data
      this.$modal.show('viewPopup')
    },
    hidePopup () {
      this.$modal.hide('viewPopup')
    },
    addMember () {
      this.$router.push({
        name: 'MemberForm',
        params: {
          type: 'add',
          searchParams: this.searchParams
        }
      })
    },
    editMember (item) {
      this.$router.push({
        name: 'MemberForm',
        params: {
          type: 'edit',
          searchParams: this.searchParams,
          data: item.userPid
        }
      })
    },
    downloadExcel () {
      if (this.excelDownloading) {
        common.amsAlert('general', '이미 다운로드 처리중입니다.')
        return
      }
      if (confirm('엑셀 다운로드는 데이터 양에 따라 상당한 시간이 소요될 수 있으며 데이터 10만개당 하나의 파일로 다운로드 됩니다.\n또한 브라우저 보안정책에 따라 연속 다운로드 권한을 허용해야합니다.\n정말 다운로드 하시겠습니까?')) {
        this.progressMsg = '다운로드 준비중...'
        this.$modal.show('loadingProgress')
        this.vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        this.$refs.excel.runExport()
        this.excelDownloading = true
      }
    },
    excelDownloadStarted () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    excelDownloadFail () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    }
  }
}
</script>

<style scoped>
#memberList {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

#memberList .btn_search {
  flex-shrink: 0;
  width: 180px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #E2E8ED;
  background: #3E7EFF;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  line-height: 56px;
  cursor: pointer;
}

#memberList .common_list_middle > .common_list_head > div,
#memberList .common_list_middle > .common_list_body > div > div {
  flex-shrink: 1;
  width: 100%;
}

#memberList .common_list_middle > .common_list_head > div:nth-child(1),
#memberList .common_list_middle > .common_list_body > div > div:nth-child(1) {
  flex-shrink: 0;
  width: 13px;
}

#memberList .common_bottom_wrap > select {
  margin: auto 0;
}

#memberList .common_bottom_wrap > .btn_apply {
  margin: auto 0 auto 7px;
}

#memberList .common_bottom_wrap > .btn_green_t {
  margin: auto 0 auto auto;
}
</style>



// WEBPACK FOOTER //
// src/components/member/MemberList.vue